module.exports = __webpack_public_path__ + "img/full.e91a8d4f.jpg";